import React from 'react';
import VideoThumnail from '../../../ProductNew/VideoReviews/VideoThumbnail';
import { calculatePaddingTop } from '../../utils';
import { GeneralSectionCover } from '../styled';
import {
  HorizontalSectionCoverStyle,
  SubHeadingDescriptionStyle,
  SubHeadingStyle,
} from './styled';

function HorizontalVideoSection(props) {
  const { data, categoryId } = props;
  const { heading, subHeading } = data;
  const imageRatioMobile = calculatePaddingTop(data?.mobileImageRatio);
  const imageRatioDesktop = calculatePaddingTop(data?.desktopImageRatio);
  return (
    <GeneralSectionCover>
      {heading && <SubHeadingStyle>{heading}</SubHeadingStyle>}
      {subHeading && (
        <SubHeadingDescriptionStyle>{subHeading}</SubHeadingDescriptionStyle>
      )}
      <HorizontalSectionCoverStyle>
        {data?.items?.map((element, index) => {
          const videUrlData = {
            videoUrl: element.videoUrl,
            thumbnailImage: element.image,
          };
          const categoryVideoData = {
            id: categoryId,
            section_name: data?.itemName,
            section_id: data?._id,
            cardName: '',
            card_id: element?._id || '',
            deeplink_value: '',
          };
          return (
            <VideoThumnail
              videoData={videUrlData}
              itemId={`element-${index}`}
              key={`element-${index}`}
              index={index}
              category={true}
              imageRatioMobile={imageRatioMobile}
              imageRatioDesktop={imageRatioDesktop}
              categoryVideoData={categoryVideoData}
            />
          );
        })}
      </HorizontalSectionCoverStyle>
    </GeneralSectionCover>
  );
}

export default HorizontalVideoSection;
